import angular from 'angular';
import { Organization } from '../../organizations';
import newActivityModalTemplate from './new-activity-modal.html';

class NewActivityModalController {
  static $inject = ['Activity'];

  modalInstance: any;
  member: any;
  organizations: Organization[] = [];

  activity: any;
  activities: any[] = [];
  selectedActivity: any;

  constructor(private Activity) { }

  $onInit() {
    this.activity = this.Activity.create({
      id: '',
      name: '',
      organization: this.organizations[0],
      type: 'BILLABLE',
      members: [],
      reference: '',
      workload: null,
    });

    this.Activity.query().then((activities) => {
      this.activities = activities;
    });
  }

  activitySelected(activity) {
    //Copy activity to avoid modifying activities scope variable
    this.activity = angular.copy(activity);
    this.selectedActivity = activity;
  }

  checkSelection(activity) {
    //Clear id and members when an existing activity is no more selected
    if (this.selectedActivity && this.selectedActivity.name != activity.name) {
      activity.id = '';
      activity.members = [];
    }
  }

  ok() {
    //Capitalize the activity name
    this.activity.name.capitalize();

    if (this.member) {
      if (!this.activity.members) {
        this.activity.members = [];
      }
      this.activity.members.push(this.member);
    }

    this.modalInstance.close(this.activity);
  }

  cancel() {
    this.modalInstance.dismiss('cancel');
  }

  canBeLinkedToMember(activity) {
    if (!activity.id) {
      return false;
    }

    if (typeof activity.members === 'undefined') {
      return true;
    } else {
      return !activity.members.find((m) => m.id === this.member.id);
    }
  }
}

export const NewActivityModalComponent = {
  template: newActivityModalTemplate,
  bindings: {
    modalInstance: '<',
    member: '<',
    organizations: '<',
  },
  controller: NewActivityModalController,
};